import React from "react"

import FoodModalKeypad from "./FoodModalKeypad"
import FoodModalRightSideHeader from "./FoodModalRightSideHeader"
import classes from "./index.module.scss"

const FoodModalRightSide = props => {
  const {
    food,
    form,
    setForm,
    focuedInputName,
    setFocuedInputName
  } = props

  const {
    salePrice: foodSalePrice,
    stockManagement,
    availableQuantity
  } = food.options.find(o => o._id === form.optionId)

  const maxQuantity =
    stockManagement ? availableQuantity : null

  const haveAddOns =
    food.specificationIds.length > 0

  return (
    <div className={classes["left"]}>
      <FoodModalRightSideHeader
        form={form}
        unit={food.unit}
        haveAddOns={haveAddOns}
        focuedInputName={focuedInputName}
        setFocuedInputName={setFocuedInputName}
      />

      <FoodModalKeypad
        unit={food.unit}
        form={form}
        setForm={setForm}
        haveAddOns={haveAddOns}
        foodSalePrice={foodSalePrice}
        maxQuantity={maxQuantity}
        focuedInputName={focuedInputName}
      />
    </div>
  )
}

export default FoodModalRightSide